/**
 * Converts Celsius to Fahrenheit
 *
 * @param celsius - Temperature in Celsius
 * @returns Temperature in Fahrenheit, rounded to the nearest integer
 */
export const convertToFahrenheit = (celsius: number): number => {
    return Math.round((celsius * 9) / 5 + 32);
};

/**
 * Converts the icon ID from the weather API to an icon class name
 * 
 * @param iconID - The icon ID from the weather API
 * @returns The icon class name
 */
export const convertIcon = (iconID: string): string => {
    return iconMap[iconID] || 'weather-sun-fill';
};

/**
 * map of icon IDs to icon class names
 */
const iconMap: Record<string, string> = {
    '01d': 'weather-sun-fill',
    '01n': 'weather-moon-stars-fill',
    '02n': 'weather-moon-stars-fill',
    '02d': 'weather-cloud-sun-fill',
    '50d': 'weather-cloud-sun-fill',
    '50n': 'weather-cloud-sun-fill',
    '03d': 'weather-cloud-sun-fill',
    '03n': 'weather-cloud-sun-fill',
    '04d': 'weather-cloud-fill',
    '04n': 'weather-cloud-fill',
    '13d': 'weather-cloud-fill',
    '13n': 'weather-cloud-fill',
    '09d': 'weather-cloud-rain-fill',
    '09n': 'weather-cloud-rain-fill',
    '10d': 'weather-cloud-rain-fill',
    '10n': 'weather-cloud-rain-fill',
    '11d': 'weather-lightning-charge-fill',
    '11n': 'weather-lightning-charge-fill',
};
